import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Enregistre une visite de page (une fois par session et par chemin).
// L'adresse IP n'est jamais envoyée : c'est le serveur qui la lit et l'anonymise.
export function trackVisit(path) {
  try {
    if (path.startsWith("/admin")) return;
    let sid = sessionStorage.getItem("memorium-visit-session");
    if (!sid) {
      sid =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem("memorium-visit-session", sid);
    }
    const key = `memorium-tracked-${path}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    axios
      .post(`${API}/track`, {
        path,
        session_id: sid,
        referrer: document.referrer || null,
      })
      .catch(() => {});
  } catch {
    // Le suivi ne doit jamais bloquer le site.
  }
}
